import {FiltrosDeInstalacaoProduto, ResultadoFiltroInstalacaoProduto} from './../../model/filtros';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import {Operacao, Layout, InstalacaoProduto, Cliente, Servico, ItemConfiguracao} from '../../model/catalogo';
import {
    ResultadoFiltroFta,
    ResultadoFiltroFta2,
    ResultadoListaFtaSia,
    FiltrosDeServico,
    ResultadoFiltroServico,
    ResultadoFiltroOperacao,
    FiltrosDeLayout,
    ResultadoFiltroLayout
} from '../../model/filtros';
import {GlobalService} from '../global.service';

@Injectable()
export class PesquisasFiltroApiService {

    paginaAtual: number = 1;
    porPagina: number = 10;
    resultados: number;
    resultadoTotal: number;

    constructor(public http: HttpClient, public globalService: GlobalService) {
    }

    public mudarPagina(pagina: number) {
        this.paginaAtual = pagina;
    }

    public mudarResultadosPorPagina(porPagina: number) {
        this.porPagina = porPagina;
    }

    // public listaFtaSia(codigo: number, versao: number): Observable<ResultadoListaFtaSia> {

    //     let url = this.globalService.getConfiguracao().api_catalogo + "/fta/filtra";

    //     return this.http.get<ResultadoListaFtaSia>(url, 
    //         { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'} });
    // }

    // public filtraFta(filtros: Array<any>): Observable<ResultadoFiltroFta> {
    //     let url = this.globalService.getConfiguracao().api_catalogo + "/fta/filtra";
    //     let data = JSON.stringify(
    //         {
    //             "metadata": { "pagina": this.paginaAtual, "porPagina": this.porPagina },
    //             "filtros": filtros
    //         });

    //     return this.http.post<ResultadoFiltroFta>(url, data,
    //         { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
    // }

    public filtraFta2(filtros: any): Observable<ResultadoFiltroFta2> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/fta/filtra/v2';
        let data = JSON.stringify(filtros);

        return this.http.post<ResultadoFiltroFta2>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    // public filtraFtaSemMetadata(filtros: Array<any>): Observable<ResultadoFiltroFta> {
    //     let url = this.globalService.getConfiguracao().api_catalogo + "/fta/filtra";
    //     let data = JSON.stringify(
    //         {
    //             "filtros": filtros
    //         });

    //     return this.http.post<ResultadoFiltroFta>(url, data, 
    //         { headers: { 'Content-Type': 'application/json; charset=utf-8'} });
    // }

    public filtraFtaDashboard(filtros: any): Observable<ResultadoFiltroFta2> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/fta/filtra/v2';
        let data = filtros;

        return this.http.post<ResultadoFiltroFta2>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public filtraFtaRoteiro(filtros: any): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/roteiro/roteiros';
        let data = filtros;
        return this.http.get<any>(
            url,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}}
        );
    }

    public detalhaFtaRoteiro(codFTA: any, vrsFTA: any): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + `/roteiro/${codFTA}/${vrsFTA}`;
        return this.http.get<any>(url,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public gerarFtaRoteiro(codFTA: any, vrsFTA: any): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + `/roteiro/geraRoteiro/${codFTA}/${vrsFTA}`;
        return this.http.get<any>(url,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public marcaExecutadoFtaRoteiro(codFTA: any, vrsFTA: any, nr: any): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + `/roteiro/${codFTA}/${vrsFTA}/${nr}`;
        return this.http.patch<any>(url,
            {headers: {'Content-Type': 'application/json, application/json-patch+json; charset=utf-8'}});

    }

    public filtraOperacao(filtros: Array<any>): Observable<Array<Operacao>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/filtra';
        let data = JSON.stringify({'filtros': filtros});

        return this.http.post<Array<Operacao>>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response['operacoes']);
    }

    public filtraOperacaoPaginado(filtros: FiltrosDeServico): Observable<ResultadoFiltroOperacao> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/filtra';
        let data = JSON.stringify(filtros);
        return this.http.post<ResultadoFiltroOperacao>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }


    async filtraOperacaoPaginadoPromise(filtros: FiltrosDeServico): Promise<ResultadoFiltroOperacao> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/filtra';
        let data = JSON.stringify(filtros);
        return await this.http.post<ResultadoFiltroOperacao>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise();
    }


    public filtraLayout(filtros: Array<any>): Observable<Array<Layout>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/layout/filtra';
        let data = JSON.stringify({'filtros': filtros});

        return this.http.post<Array<Layout>>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response['layouts']);

    }

    public filtraInstalacaoProduto(filtros: Array<any>): Observable<Array<InstalacaoProduto>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/instalacaoProduto/filtra';
        let data = JSON.stringify({'filtros': filtros});

        return this.http.post<Array<InstalacaoProduto>>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response['instalacoesProduto']);

    }

    async filtraInstalacaoProdutoPaginacaoPromise(filtros: FiltrosDeInstalacaoProduto): Promise<ResultadoFiltroInstalacaoProduto> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/instalacaoProduto/filtra';
        let data = JSON.stringify({'filtros': filtros});

        return await this.http.post<ResultadoFiltroInstalacaoProduto>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise();
    }

    filtraInstalacaoProdutoPaginacao(filtros: FiltrosDeInstalacaoProduto): Observable<ResultadoFiltroInstalacaoProduto> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/instalacaoProduto/filtra';
        let data = JSON.stringify({'filtros': filtros});

        return this.http.post<ResultadoFiltroInstalacaoProduto>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public filtraCliente(filtros: Array<any>): Observable<Array<Cliente>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/cliente/filtra';
        let data = JSON.stringify({'filtros': filtros});

        return this.http.post<Array<Cliente>>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response['clientes']);
    }

    public filtraServico(filtros: any): Observable<Array<Servico>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/servico/filtra';
        let data = JSON.stringify(filtros);

        return this.http.post<Array<Servico>>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response['servicos']);

    }

    public filtraServicoPaginado(filtros: FiltrosDeServico): Observable<ResultadoFiltroServico> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/servico/filtra';
        let data = JSON.stringify(filtros);
        return this.http.post<ResultadoFiltroServico>(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public filtraUsuariosVinculados(filtroCliente: any): Promise<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/cliente/filtra/';
        let data = JSON.stringify({'filtros': [filtroCliente]});

        return this.http.post(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise();
    }

    async filtraServicoPaginadoPromisse(filtros: FiltrosDeServico): Promise<ResultadoFiltroServico> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/servico/filtra';
        let data = JSON.stringify(filtros);
        return await this.http.post<ResultadoFiltroServico>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise();
    }

    public filtraLayoutPaginado(filtros: FiltrosDeLayout): Observable<ResultadoFiltroLayout> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/layout/filtra';
        let data = JSON.stringify(filtros);

        return this.http.post<ResultadoFiltroLayout>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    async filtraLayoutPaginadoPromise(filtros: FiltrosDeLayout): Promise<ResultadoFiltroLayout> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/layout/filtra';
        let data = JSON.stringify(filtros);

        return await this.http.post<ResultadoFiltroLayout>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise();
    }

    public filtraItemConfiguracao(filtros: Array<any>): Observable<Array<ItemConfiguracao>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/itemConfiguracao/filtra';
        let data = JSON.stringify({'filtros': filtros});

        return this.http.post<Array<ItemConfiguracao>>(url, data,
            {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response['itensConfiguracao']);

    }

}



// WEBPACK FOOTER //
// ./src/service/api/pesquisas-filtro.api.ts